import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Card, CardContent } from "@/components/ui/card";
import MainLayout from "@/components/layout/MainLayout";
import { ArrowLeft, Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CustomerInfoForm from "@/components/rentals/CustomerInfoForm";
import BikeSelectionForm from "@/components/rentals/BikeSelectionForm";
import PlanSelectionForm from "@/components/rentals/PlanSelectionForm";
import { useRentalForm } from "@/hooks/useRentalForm";

const NewRental = () => {
  const navigate = useNavigate();
  const {
    form,
    selectedCustomer,
    searchTerm,
    selectedBikes,
    selectedPlan,
    bikes,
    plans,
    durationHours,
    totalAmount,
    expectedReturnTime,
    isLoading,
    profile,
    handleCustomerSelect,
    handleSearchChange,
    handleBikesChange,
    handlePlanChange,
    handleDurationChange,
    onSubmit
  } = useRentalForm();

  // Check if the user profile exists and has branch information
  if (!profile) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center h-[70vh]">
          <h1 className="text-2xl font-bold mb-4">Cargando información de usuario...</h1>
          <p>Por favor espere mientras obtenemos sus datos.</p>
        </div>
      </MainLayout>
    );
  }

  if (!profile.branch_id) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center h-[70vh]">
          <h1 className="text-2xl font-bold mb-4">Sin sucursal asignada</h1>
          <p>No tiene una sucursal asignada. Contacte al administrador.</p>
          <Button 
            className="mt-4" 
            onClick={() => navigate("/rentals-operator")}
          >
            Volver a alquileres
          </Button>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold text-gray-800">Nuevo Alquiler</h1>
        </div>
        
        <Card>
          <CardContent className="pt-6">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5">
                <CustomerInfoForm 
                  form={form} 
                  selectedCustomer={selectedCustomer}
                  onCustomerSelect={handleCustomerSelect}
                  searchTerm={searchTerm}
                  onSearchChange={handleSearchChange}
                />
                
                <BikeSelectionForm 
                  form={form} 
                  bikes={bikes} 
                  selectedBikes={selectedBikes} 
                  handleBikesChange={handleBikesChange} 
                />
                
                <PlanSelectionForm
                  form={form}
                  plans={plans}
                  selectedPlan={selectedPlan}
                  onPlanChange={handlePlanChange}
                  durationHours={durationHours}
                  onDurationChange={handleDurationChange}
                  totalAmount={totalAmount}
                  expectedReturnTime={expectedReturnTime}
                />
                
                <div className="flex justify-end gap-2">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => navigate(-1)}
                    disabled={isLoading}
                  >
                    Cancelar
                  </Button>
                  <Button type="submit" disabled={isLoading}>
                    <Save className="mr-2 h-4 w-4" />
                    Registrar
                  </Button>
                </div>
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default NewRental;
